var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAvatar11 = function SvgAvatar11(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avatar-11_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5C400",
    d: "M60 30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30 16.569 0 30-13.431 30-30Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00CA69",
    d: "M38.188 7.05s2.295 9.043-7.433 12.39c0 0-1.857-10.683 7.433-12.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#794B37",
    d: "M29.808 19.657h.385c.443 0 .802-.359.802-.802V12.56a.803.803 0 0 0-.802-.803h-.385a.803.803 0 0 0-.803.803v6.295c0 .443.36.802.803.802Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6651",
    d: "m15.095 22.968.005.01c1.732-3.313 5.38-5.598 9.598-5.598 1.932 0 3.744.48 5.307 1.318a11.216 11.216 0 0 1 5.308-1.318c4.215 0 7.857 2.277 9.592 5.585 0 0 4.492 7.613.86 16.323-2.008 5.695-8.303 9.85-15.76 9.85-7.46 0-13.758-4.16-15.762-9.858l-.008.008c-3.633-8.71.86-16.323.86-16.323v.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E25344",
    d: "M43.628 37.245c.162-.775.282-1.563.37-2.362.407-3.713-.048-7.523-1.8-10.86-1.735-3.308-5.04-5.88-9.255-5.88-.775 0-1.53.077-2.258.224 1.4-.63 2.97-.982 4.628-.982 4.215 0 7.857 2.277 9.592 5.585 0 0 4.493 7.613.858 16.322-1.965 4.713-6.045 8.185-11.095 9.225 1.247-.257 2.65-1.367 3.622-2.145 2.855-2.287 4.598-5.58 5.338-9.124v-.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.878 26.293a1.82 1.82 0 1 0 0-3.64 1.82 1.82 0 0 0 0 3.64Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "avatar-11_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
};
export { SvgAvatar11 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-11.56fb542b40a5e285fdca.svg";